export default "__VITE_ASSET__YM8Qmoja__"